import $ from 'gridstrap/lib/gs-zepto';
import { templates } from '../template';
import { data } from '../data';

export class GSScreenshotCarouselService {

	//
	// Properties
	//

	private carousel;

	get isCarouselOpen() { return $('body').hasClass('modal-open'); }
	set isCarouselOpen(value) { $('html, body').toggleClass('modal-open', !!value); }

	//
	// Methods
	//

	async open(image, path = location.pathname, callback?) {
		if (this.isCarouselOpen) return;
		if (!image) return;

		let bindingData = await data.get('product');
		let html = templates.render('screenshot-carousel', bindingData);

		this.isCarouselOpen = true;
		this.carousel = $(html);
		this.carousel.data('gsScreenshotCarouselImage', image);
		this.carousel.appendTo('body');
		if (callback) callback();

	}

	close() {
		this.carousel.gs('isOpen', false);
		this.carousel.one('transitionend', () => {
			this.carousel.remove();
			this.carousel = undefined;
			this.isCarouselOpen = false;
		});
	}

	remove() {
		this.carousel.remove();
		this.isCarouselOpen = false;
	}
}
